import { inject, Injectable, Provider } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, ReplaySubject } from 'rxjs';
import { ISearchService, ISearchServiceToken } from './search-service.interface';
import { SearchState } from './search-state.model';
import { ILoggerService, ILoggerServiceToken } from '../../infrastructure/logger/logger-service.interface';

@Injectable({
  providedIn: 'root'
})
export class SearchService implements ISearchService {

  protected readonly router: Router = inject(Router);
  protected readonly logger: ILoggerService = inject(ILoggerServiceToken);

  protected readonly searchStateSubject: ReplaySubject<SearchState>;
  protected searchState: SearchState;

  public constructor() {
    this.searchStateSubject = new ReplaySubject<SearchState>(1);
    this.searchState = new SearchState();
  }

  public searchStateGet(): SearchState {
    return this.searchState;
  }

  public searchStateChangedGet(): Observable<SearchState> {
    return this.searchStateSubject.asObservable();
  }

  public searchStateSet(searchState: SearchState, doNavigation: boolean) {
    this.searchState = searchState;
    this.searchStateSubject.next(this.searchState);

    if (doNavigation == false) {
      return;
    }

    if (searchState.searchTerm != undefined && searchState.searchTerm.length > 0) {
      this.router.navigate(["product", "search"], {
        queryParams: {
          searchText: searchState.searchTerm,
          categoryKeyFilter: searchState.categoryFilterEntryList?.filter(c => c.isSelected == true)?.map(c => c.categoryKey),
        },
      });
    }
  }

}

/**
 * Prepared provider with the token to implementation mapping.
 * Reference this at the desired provider list to enable the injection of this implementation by referencing the token(interface).
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const SearchServiceProvider: Provider[] = [
  { provide: ISearchServiceToken, useExisting: SearchService }
];
